<div #alertConfirm [ngClass]="classname">
  @if (type==SUCCESS && showTypeIcon===true) {
    <img alt="logo" src="../../assets/success.png" />
  }
  @if (type==ERROR && showTypeIcon===true) {
    <img alt="logo" src="../../assets/error.png" />
  }
  @if ((type==WARNING || type==INFO_BACKGROUND) && showTypeIcon===true) {
    <img alt="logo" src="../../assets/warning.png" />
  }
  <h4>{{title}}</h4>
  @for (item of items; track item) {
    <p>{{item}}</p>
  }
  <p [ngStyle]="{'color': messageColor, 'font-size.px': messageFontSize}">{{message}}</p>
  @if (textIconItems.length > 0) {
    <div>
      @for (item of textIconItems; track item) {
        <div>
          <span>{{item.text}} </span>
          <mat-icon class="{{item.iconClass}}">{{item.matIcon}}</mat-icon>
        </div>
      }
    </div>
  }
  @if (progressValue > -1) {
    <mat-progress-bar
      class="custom-progress-bar-blue"
      [color]="color"
      [mode]="mode"
      [value]="progressValue"
      style="height: 14px; border-radius: 3px; margin-bottom: 14px;">
    </mat-progress-bar>
  }
  <br>
    <div class="button-container">
      @if (type==CONFIRM) {
        <button type="button" class="btn button-fix button-color-fix-green" (click)="onYes()">Yes</button>
      }
      @if (type==CONFIRM) {
        <button type="button" class="btn button-fix button-color-fix-red" (click)="onNo()">No</button>
      }
      @if (type!=CONFIRM && type != INFO_BACKGROUND) {
        <button type="button" class="btn button-fix button-color-fix-green" (click)="onOk()">Ok</button>
      }
    </div>
  </div>
